import type {
  BindingTargetDetails,
  BoundObjectRef,
  FailedToFindBindingCandidatesError,
} from '@wix/editor-platform-feature-store';
import type {
  AttachState,
  BindingCandidate,
  BindingProperties,
  ListBindingsOptions,
  UnbindAll,
  BindingDetailsMap,
} from '@wix/public-editor-platform-interfaces';

import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { DependencyToken } from '../dependencies';

export class ExternalBindingsHandler extends AbstractExternalAPIHandler {
  bind(target: BoundObjectRef, bindings: BindingProperties[]) {
    return this.dependenciesContributor.get(DependencyToken.BINDINGS_BIND)(
      target,
      bindings,
    );
  }

  setBinding(target: BoundObjectRef, bindings: BindingDetailsMap) {
    return this.dependenciesContributor.get(
      DependencyToken.BINDINGS_SET_BINDING,
    )(target, bindings);
  }

  unbind(target: BoundObjectRef, props: string[] | UnbindAll) {
    return this.dependenciesContributor.get(DependencyToken.BINDINGS_UNBIND)(
      target,
      props,
    );
  }

  listBindings(target: BoundObjectRef, options?: ListBindingsOptions) {
    return this.dependenciesContributor.get(DependencyToken.BINDINGS_LIST)(
      target,
      options,
    );
  }

  getBinding(target: BoundObjectRef, options?: ListBindingsOptions) {
    return this.dependenciesContributor.get(
      DependencyToken.BINDINGS_GET_BINDING,
    )(target, options);
  }

  findBindingCandidates(options: {
    target: BoundObjectRef;
    filterAttachState?: AttachState[];
    bindingTargetDetails: BindingTargetDetails;
    includeCandidatesWithConverters?: boolean;
  }): BindingCandidate[] | FailedToFindBindingCandidatesError {
    return this.dependenciesContributor.get(
      DependencyToken.BINDINGS_FIND_BINDING_CANDIDATES,
    )(options);
  }
}
